import script from "./InfoPointsComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoPointsComponent.vue?vue&type=script&setup=true&lang=js"

import "./InfoPointsComponent.vue?vue&type=style&index=0&id=11c5818a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11c5818a"]])

export default __exports__